import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';

import './ScrollIndicator.scss';

const cx = classNames;

export class ScrollIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: false,
      right: false,
      bottom: false,
      left: false,
    };
  }

  componentDidMount() {
    this.handleScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.handleScroll();
    }
  }

  handleScroll = () => {
    const hasHorizontalScrollbar =
      this.scrollableElement.clientWidth < this.scrollableElement.scrollWidth;
    const hasVerticalScrollbar =
      this.scrollableElement.clientHeight < this.scrollableElement.scrollHeight;

    const scrolledFromLeft =
      this.scrollableElement.offsetWidth + this.scrollableElement.scrollLeft;
    const scrolledFromTop =
      this.scrollableElement.offsetHeight + this.scrollableElement.scrollTop;

    const scrolledToTop = this.scrollableElement.scrollTop === 0;
    const scrolledToRight =
      scrolledFromLeft >= this.scrollableElement.scrollWidth;
    const scrolledToBottom =
      scrolledFromTop >= this.scrollableElement.scrollHeight;
    const scrolledToLeft = this.scrollableElement.scrollLeft === 0;

    this.setState({
      top: hasVerticalScrollbar && !scrolledToTop,
      right: hasHorizontalScrollbar && !scrolledToRight,
      bottom: hasVerticalScrollbar && !scrolledToBottom,
      left: hasHorizontalScrollbar && !scrolledToLeft,
    });
  };

  render() {
    const { size, className, children, ...props } = this.props;

    const { top, right, bottom, left } = this.state;

    const classes = cx(
      'c-scroll-indicator',
      {
        [`c-scroll-indicator--${size}`]: size,
      },
      className,
    );

    return (
      <div
        className={classes}
        onScroll={this.handleScroll}
        ref={r => {
          this.scrollableElement = r;
        }}
        {...props}>
        {children}
        <span
          className={`c-scroll-indicator__shadow c-scroll-indicator__shadow--top ${
            top && 'c-scroll-indicator__shadow--active'
          }`}
        />
        <span
          className={`c-scroll-indicator__shadow c-scroll-indicator__shadow--right ${
            right && 'c-scroll-indicator__shadow--active'
          }`}
        />
        <span
          className={`c-scroll-indicator__shadow c-scroll-indicator__shadow--bottom ${
            bottom && 'c-scroll-indicator__shadow--active'
          }`}
        />
        <span
          className={`c-scroll-indicator__shadow c-scroll-indicator__shadow--left ${
            left && 'c-scroll-indicator__shadow--active'
          }`}
        />
      </div>
    );
  }
}

ScrollIndicator.propTypes = {
  /**
   * Component width
   */
  width: PropTypes.string,
  /**
   * Component height
   */
  height: PropTypes.string,
  /**
   * Shadow Indicator size
   */
  size: PropTypes.oneOf(['medium', 'large']),
  /**
   * Extend the classNames applied to the component
   */
  className: PropTypes.string,
  /**
   * Extend the styles applied to the component
   */
  style: PropTypes.object,
  children: PropTypes.any,
};

ScrollIndicator.defaultProps = {
  width: '100%',
  height: '100%',
  size: 'medium',
  className: '',
};
